<template lang="pug">
  .product-bottomline
    .product-bottomline__rating(v-if="loaded")
      star-rating.product-bottomline__stars(
        :rating="rating"
        v-if="rating > 0 || displayNoReviews"
      )
      a.product-bottomline__count(v-if="count > 0" href="#" v-scroll-to="{ el: '#pdp_yotpo_reviews' }") {{ reviewMessage }}
      a.product-bottomline__no-ratings(v-else-if="loaded && displayNoReviews" href="#" v-scroll-to="{ el: '#pdp_yotpo_reviews' }") No reviews yet!
</template>

<script>
  import StarRating from 'scripts/components/basic/StarRating.vue';

  // add client APPKEY here (public facing)
  const YOTPO_APP_KEY = 'aOHeB8HyNCp6L6AWQwoCr9hpPSfeHkCNvYSvM9FB';

  export default {
    name: 'ProductBottomLine',
    components: { StarRating },
    data () {
      return {
        loaded: false,
        rating: 0,
        count: 0,
      }
    },
    props: {
      productId: Number,
      displayMobileReviewMessage: {
        type: Boolean,
        default: false,
      },
      displayNoReviews: {
        type: Boolean,
        default: true,
      },
    },
    created() {
      fetch(`https://api.yotpo.com/products/${YOTPO_APP_KEY}/${this.productId}/bottomline`)
        .then((blob) => blob.json())
        .then((data) => {
          // endpoint returns => average_score and total_reviews
          const count = data.response.bottomline.total_reviews || 0;

          this.count = count;
          if (count > 0) this.rating = data.response.bottomline.average_score;
        })
        .finally(() => this.loaded = true)
        .catch((err) => console.error(err.response.data.status.message));
    },
    computed: {
      reviewMessage () {
        if (this.$mq === 'mobile' && this.displayMobileReviewMessage === false) return `(${this.count})`;
        return `(${this.count} Reviews)`;
      },
    },
  };
</script>

<style scoped lang="scss">
  .product-bottomline {
    &__rating {
      display: flex;
      align-items: center;
    }

    &__stars {
      margin-right: 8px;
      height: 18px;
      font-size: 0;
    }

    &__count,
    &__no-ratings {
      margin: 0;
      font-family: $font-gibson;
      font-size: rem(12);
      line-height: 1;
    }
  }
</style>
